document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const mobile = document.querySelector('[data-mobile-nav]');
  if (toggle && mobile) {
    toggle.addEventListener('click', () => {
      mobile.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', mobile.classList.contains('is-open'));
    });
  }

  const drawer = document.querySelector('[data-cart-drawer]');
  document.querySelectorAll('[data-cart-open]').forEach(btn => btn.addEventListener('click', e => {
    e.preventDefault();
    drawer?.classList.add('is-open');
  }));
  document.querySelectorAll('[data-cart-close]').forEach(btn => btn.addEventListener('click', () => {
    drawer?.classList.remove('is-open');
  }));

  document.querySelectorAll('[data-qty]').forEach(group => {
    const input = group.querySelector('input');
    group.querySelector('[data-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, Number(input.value || 1) - 1);
    });
    group.querySelector('[data-plus]')?.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
    });
  });

  document.querySelectorAll('[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const body = new FormData(form);
      const button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;
      try {
        await fetch('/cart/add.js', { method:'POST', headers:{Accept:'application/json'}, body });
        const drawer = document.querySelector('[data-cart-drawer]');
        drawer?.classList.add('is-open');
        if (drawer) drawer.dispatchEvent(new CustomEvent('nc:cart-refresh'));
        window.dispatchEvent(new Event('cart:refresh'));
      } catch(err) {
        form.submit();
      } finally {
        if (button) button.disabled = false;
      }
    });
  });
});